import { TOAST } from '@commoncore/constants/ToastMessages';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import { SessionStorageProps } from '@commoncore/enums/sessionStorageProps';
import { ListViewImplementation } from '@commoncore/implementation/ListViewImplementation';
import { CustomSortService } from '@commoncore/services/custom-sort.service';
import { MultiSelectLibrary } from '@commoncore/utils/MultiSelectUtil';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';


export class PreLoginSharedViewListImplementation {
  public router: any;
  public http: any;
  public route: any;
  public universalService: any;
  public multiSelect: any;
  public listService: any;
  contextMenuService: any;
  customMetadata: any;
  public sortType = "%2DlastModifiedDate";
  public sortByDateArray = [];
  customSort:any;
  listImpl:any;
  loggerService: any;
  receivedEmpty: boolean;
  public nextLink: string="";
  public flag = false;
  public previousLink: string = "";
  public docheignt: number = 0;
  public toppos: number = 0;
  shareAccessService:any;
  localStorageService:any;
  sessionStorageService:any;
  errorMessage:string = "";
  // cookie:any;
  static singleInstance:any = null;
  globalService: any;

  constructor(globalService) {
    this.universalService = globalService.getUniversalServiceRef();
    this.globalService = globalService;
  }


  public static getInstance(globalService):PreLoginSharedViewListImplementation{
		if(this.singleInstance == null){
			this.singleInstance = new PreLoginSharedViewListImplementation(globalService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
  }

  public setHandler(globalService) {
    this.router = globalService.getRouterRef();
    this.http = globalService.getHttpClientRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.contextMenuService = globalService.getContextMenuServiceRef();
    this.route = globalService.getActivatedRoute();
    this.loggerService = globalService.getLoggerServiceRef();
    this.multiSelect = MultiSelectLibrary.getInstance(globalService);
    this.listService = globalService.getListServiceRef();
    this.listImpl = ListViewImplementation.getInstance(globalService)
    this.customMetadata = globalService.getCustomMetadataServiceRef();
    this.customSort = new CustomSortService(this.universalService);
    this.shareAccessService = globalService.getShareAccessServiceRef();
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.sessionStorageService = globalService.getSessionStorageSvcRef();
    // this.cookie = globalService.getCookieServiceRef();
  }

  setDataAsPerDeviceAndView(files){
    this.shareAccessService.listsize = this.shareAccessService.listsize + files.length;
    if(this.universalService.isMobileDevice){
        this.setDataForMobile(files);
    }else {
      this.setDataForDesktop(files);
    }
  }

  setDataForDesktop(files){
    var sortType = 'receiveddefault'; // this is used to set the default definitions for the prelogin list view
    if(this.universalService.listView){
        this.setDataForListView(files,sortType);
    }else{
        this.setDataForGridView(files);
    }
  }

  setDataForMobile(files){
    this.bindMultiSelect();
    this.sortByDates(files);
  }


  setDataForListView(files,sortType){
    this.listImpl.decideListOptions(sortType);
    this.listImpl.fetchReceivedFilesListView(files);
  }

  setDataForGridView(files){

  }


  resetValuesBeforeSettingData(){
    this.universalService.listView = true;
    this.shareAccessService.nextLink = "";
    this.previousLink = "";
    this.universalService.showLoader = true;
    this.sortByDateArray = [];
    this.listService.resetColumnHeaders();
    this.listService.cellclick = false;
    this.errorMessage = "";
    this.universalService.selectedNodes = [];
    this.shareAccessService.sharedFilesList = [];
    this.universalService.emptyShared = false;
    this.universalService.mobileSelectedObj = [];
    this.universalService.objectsPreviewArray = [];
    this.universalService.foldersArray = [];
    this.universalService.scrollToTopIcon = false;
    this.shareAccessService.listsize = 0;
    this.universalService.scrollToTopIcon = false;
  }

  checkIfPublicOrRestricted(url){
    var self = this;
    return new Promise(function(resolve,reject){
        self.http.get(url).subscribe(
            resp=>{
                self.resetValuesBeforeSettingData();
                self.checkIfTabIsEmpty(resp["objects"]?resp["objects"]:[])
                self.fetchNextLink(resp);
                var result = self.decideWhichPageToLoad(resp);
                if(result == "openPreview"){
                  resolve("open")
                }else{
                  resolve(resp)
                }
                
            },
            err=>{
                console.log("checkIfPublicOrRestricted  err is ::",err)
                self.checkErrorStatus(err);
                reject(err);
            }
        )
    })
  }

  decideWhichPageToLoad(resp){
    var self = this;
    var objects = self.customMetadata.segregateData(resp,"allfiles");
    if(objects.length == 0){
      self.universalService.emptyFolder = true;
    }else{
      self.universalService.emptyFolder = false;
    }
    if(resp.objects && resp.objects.length == 1){
      self.shareAccessService.singleObjectShared = objects;
      var temp = self.sessionStorageService.getSingleSharedObject(true);
      if(!temp) {
        self.sessionStorageService.setSingleSharedObject(this.shareAccessService.singleObjectShared,true);
        self.sessionStorageService.setObjectWithExpiry(SessionStorageProps.SINGLE_SHARED_OBJECT_WITH_EXPIRY, this.shareAccessService.singleObjectShared);
      }
    }
    self.shareAccessService.sharedObjectsList = objects
    if(self.universalService.userLoggedIn){
      self.redirectToSharedWithMeForLoggedInUser();
      return
    }else{
      self.shareAccessService.isPublicLink = true;
      self.setDataAsPerDeviceAndView(this.shareAccessService.sharedObjectsList)
    }
    if (resp.objects.length == 1){
      var temp = self.sessionStorageService.getSingleSharedObject(true);
      if(temp==undefined) self.universalService.hideLeftMenu = true;
      return "openPreview"
    }
  }

  checkErrorStatus(err){
    var self = this;
    var msg = "";
    console.log("checkErrorStatus  err is ::",err)
    self.sessionStorageService.setSingleSharedObject("",true)
    self.sessionStorageService.setObjectWithExpiry(SessionStorageProps.SINGLE_SHARED_OBJECT_WITH_EXPIRY, "");
    if(err.error.code.includes("500")){
      self.universalService.showToast(TOAST["GENERIC_ERROR"],"error");
      self.redirectToHomePage(msg);
    }
    else if(err.error.code == "NMSCL0028"){
      self.universalService.showRequestAccessScreen = true;
      AppEvents.emit(EventsList.EMPTY_TABBED_VIEW)
    }else if(err.error.code == "NMSCL0029" || err.error.code == "SCLN0050"){ // SCLN0050 is added when the gethostdc api is called in prelogin state and we have redirect user to login page
      if(this.universalService.inAppWebViewOpened) {
        self.universalService.showRequestAccessScreen = true;
      } else {
        self.sessionStorageService.setShareKey(self.shareAccessService.shareKey,true)
        self.sessionStorageService.setObjectWithExpiry(SessionStorageProps.SHARE_KEY_WITH_EXPIRY,self.shareAccessService.shareKey)
        console.log("error is ===>>",err,self.sessionStorageService.getShareKey());
        self.universalService.showToast(TOAST["LOGIN_REQUIRED_TO_ACCESS_SHARE_LINK"],'warning')
        setTimeout(() => {
          self.redirectToHomePage(msg);
        }, 2000);
      }
    } 
    else if(err.error.code == "NMSCL0011"){
      if(!self.universalService.userLoggedIn){
        self.universalService.emptyFolder = true;
        this.universalService.hideLeftMenu = false;
      }
      else{
        self.sessionStorageService.setSingleSharedObject("fileDeleted",true)
        self.redirectToSharedWithMeForLoggedInUser();
      }
    }
    else {
      msg = err.error.error
      if(err.error.code == 'NMSCL0022'){
        this.errorMessage = msg;
      }else{
        this.errorMessage = "";
      }
      self.universalService.showToast(msg, "error")
      if(this.universalService.inAppWebViewOpened){
        self.redirectToHomePage(msg);
      }
    }
    self.universalService.showLoader = false;
  }


  redirectToSharedWithMeForLoggedInUser(){
    if(this.universalService.inAppWebViewOpened){
      window.location.href = "/shared/sharedwithme"
    }else{
      var url = '/shared/sharedwithme'
      // var url = 'http://localhost:4200' + '/shared/sharedwithme'
      window.open(url,'_self', "noopener, noreferrer");
    }
    // window.open("http://localhost:4200/shared/sharedwithme",'_blank', "noopener, noreferrer");
  }

  redirectToHomePage(toastMessage){
    toastMessage = !toastMessage?"":toastMessage
    if(this.universalService.inAppWebViewOpened){
      this.listService.informAndroidAndIOSToCloseWebView(toastMessage);
      return;
    }
    var url = '/signin'
    window.open(url,'_self', "noopener, noreferrer");
  }


  fetchFolderData(url){
    var self = this;
    return new Promise(function(resolve,reject){
        self.http.get(url).subscribe(
            resp=>{
               self.resetValuesBeforeSettingData();
               self.fetchNextLink(resp);
               self.decideWhichPageToLoad(resp)
            },
            err=>{
                self.universalService.showErrorMessage(err);
                self.universalService.isServerError = false;
                self.loggerService.log("error in fetching folders data",err)
            }
        )
    })
  }

  createUrlForNextLinkOnDesktop(url) {
    var options
    options = this.listService.listOptions
    if (options.api.getVerticalPixelRange().top == 0)
      this.universalService.scrollToTopIcon = false;
    else
      this.universalService.scrollToTopIcon = true;
      if (this.shareAccessService.listsize - options.api.getLastDisplayedRow() < 3) {
        
        if ((this.previousLink != this.shareAccessService.nextLink)) {
          this.previousLink = this.shareAccessService.nextLink
          if (this.shareAccessService.nextLink != "") {
            this.universalService.showLoader = true;
            this.fetchNextPageData(url);
          } else {
  
          }
        } else {
  
        }
      }
    }
  
    createUrlForNextLinkOnMobile(docheignt, toppos, url) {
      if (toppos == 0) {
        this.universalService.scrollToTopIcon = false;
      } else {
        this.universalService.scrollToTopIcon = true;
        let checkIfContaineris95PercScrolled = this.universalService.virtualGridEnabled ? true : (toppos + $(".scrollableContainer").innerHeight()) >= (0.95 * docheignt)
        if ( checkIfContaineris95PercScrolled && this.shareAccessService.nextLink != "" && this.previousLink != this.shareAccessService.nextLink) {
          this.previousLink = this.shareAccessService.nextLink
          if (this.shareAccessService.nextLink != "") {
            this.universalService.showLoader = true;
            this.fetchNextPageData(url)
          } else {
  
          }
        }
      }
    }
  
    fetchNextPageData(url) {
      this.http.get(url).subscribe(
        nextPageData => {
          this.appendData(nextPageData)
        },
        err => {
          this.universalService.showErrorMessage(err);
        }
      )
    }
  
    appendData(nextPageData) {
      this.fetchNextLink(nextPageData)
      var list = this.customMetadata.segregateData(nextPageData, 'allfiles');
      if (!this.universalService.isMobileDevice) {
        this.shareAccessService.listsize = this.shareAccessService.listsize + list.length;
        this.listImpl.appendRowDataForReceivedFiles(list)
      } else {
        this.sortByDates(list);
      }
    }

    checkIfTabIsEmpty(list){
      if(list.length == 0){
        this.universalService.emptyShared = true
      }else{
          this.universalService.emptyShared = false;
      }
    }

    fetchNextLink(resp){
      if (resp["nextLink"]) {
        if(resp["nextLink"].includes('+')){
          this.shareAccessService.nextLink = resp["nextLink"].replace('+',"%2B")
        }else{
          this.shareAccessService.nextLink = resp["nextLink"]
        }
      } else {
        this.shareAccessService.nextLink = ""
      }
    }

    bindMultiSelect(){
        this.multiSelect = MultiSelectLibrary.getInstance(this.globalService);
        this.multiSelect.bindMultiSelectLibrary(".tab-content", "list_info", ".listItem:visible", false,this.universalService.virtualGridEnabled,false);
        this.multiSelect.bindMultiSelectUIevent(".main-wrapper", ".list_file_child");     
    }

    sortByDates(files){
      var array  = this.customSort.sortByDates(files,this.sortByDateArray,[],"modifiedDate")
      this.sortByDateArray = array[0];
      this.universalService.objectsPreviewArray = array[1];
      this.shareAccessService.sharedFilesList= array[1];
      this.loggerService.log("sort by date array",this.sortByDateArray)  
      setTimeout(() => {
          this.universalService.showLoader = false;  
      }, 10);
      AppEvents.virtualDOMObservable.next({"updateVDOM":true})
      AppEvents.multiSelectEvent.next({"dataArray":this.shareAccessService.sharedFilesList.concat(this.universalService.foldersArray)})
  }


  fetchUserProfileDetails(url){
    var self = this;
    self.universalService.ignoreUnAuthorizedError = true;
    return new Promise(function(resolve,reject){
      self.http.get(url).subscribe(
      suc=>{
        self.universalService.ignoreUnAuthorizedError = false;
        resolve({"status":200})
      },
      err=>{
        self.universalService.ignoreUnAuthorizedError = false;
        console.log("error from user details",err)
        if(err.status == 401){
          console.log("status is 401",err.status)
          self.universalService.userLoggedIn = false;
          const userData = this.localStorageSvc.getUserData(true);
          localStorage.removeItem(LocalStorageProps.JIO);
          // self.cookie.deleteAll();
          self.universalService.setWidthforLogin();
          resolve({"status":500})
        }else{
          reject(err)
        }
      }
      )
    })
  }
}